module.exports = __webpack_public_path__ + "img/21.bcd0e631.jpg";